import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const teal = '#0D9488'
const plum = '#1E1040'

export default function Help() {
  const { t } = useTranslation()
  const [openKey, setOpenKey] = useState(null)

  const sections = t('help.sections', { returnObjects: true })

  const toggle = (key) => {
    setOpenKey(openKey === key ? null : key)
  }

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>{t('help.title')}</h1>
        <p style={styles.sub}>{t('help.subtitle')}</p>
      </div>

      {Array.isArray(sections) && sections.map((section) => (
        <div key={section.section} style={styles.section}>
          <h2 style={styles.sectionTitle}>{section.section}</h2>
          <div style={styles.items}>
            {section.items.map((item, idx) => {
              const key = `${section.section}-${idx}`
              const isOpen = openKey === key
              return (
                <div key={key} style={styles.faqItem}>
                  <button
                    style={styles.qButton}
                    onClick={() => toggle(key)}
                  >
                    <span style={styles.q}>{item.q}</span>
                    <span style={{ ...styles.caret, transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>⌄</span>
                  </button>
                  {isOpen && <div style={styles.a}>{item.a}</div>}
                </div>
              )
            })}
          </div>
        </div>
      ))}

      <div style={styles.footer}>
        <p style={styles.footerText}>
          {t('help.footer_prefix')}{' '}
          <a href="mailto:hello@merqlog.com" style={styles.link}>hello@merqlog.com</a>
          {' '}{t('help.footer_suffix')}
        </p>
      </div>
    </div>
  )
}

const styles = {
  page: { padding: '32px 40px 80px', maxWidth: '800px', margin: '0 auto', fontFamily: "'Plus Jakarta Sans', sans-serif", color: plum },
  header: { marginBottom: '32px' },
  title: { fontFamily: "'Fraunces', serif", fontSize: '38px', fontWeight: 900, letterSpacing: '-1px', color: plum, margin: 0, lineHeight: 1.1 },
  sub: { fontSize: '15px', color: '#6B7280', marginTop: '6px', fontWeight: 500 },
  section: { marginBottom: '28px' },
  sectionTitle: { fontFamily: "'Fraunces', serif", fontSize: '22px', fontWeight: 800, color: plum, letterSpacing: '-0.3px', marginBottom: '12px', marginTop: '24px' },
  items: { background: '#fff', border: '1px solid #E5E7EB', borderRadius: '14px', overflow: 'hidden' },
  faqItem: { borderTop: '1px solid #F3F4F6' },
  qButton: { width: '100%', padding: '16px 20px', background: '#fff', border: 'none', textAlign: 'left', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', fontFamily: "'Plus Jakarta Sans', sans-serif", transition: 'background 0.15s' },
  q: { fontSize: '15px', fontWeight: 700, color: plum, flex: 1 },
  caret: { fontSize: '18px', color: '#9CA3AF', transition: 'transform 0.2s', flexShrink: 0 },
  a: { padding: '0 20px 20px 20px', fontSize: '14px', color: '#4B5563', lineHeight: 1.7, fontWeight: 400 },
  footer: { marginTop: '40px', padding: '20px 24px', background: '#fff', border: '1px solid #E5E7EB', borderRadius: '14px', textAlign: 'center' },
  footerText: { fontSize: '14px', color: '#6B7280', margin: 0 },
  link: { color: teal, fontWeight: 600, textDecoration: 'none' },
}
